import script from "./CollectiviteMembreDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectiviteMembreDetail.vue?vue&type=script&setup=true&lang=ts"

import "./CollectiviteMembreDetail.vue?vue&type=style&index=0&id=2a9c92f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9c92f7"]])

export default __exports__